export default {"src":"/_next/static/media/solar_planet.c55abf9d.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};